import Route from "./Routes";
import "./App.css";
import { AuthProvider, useAuth } from "./Context/Auth/AuthContext";
import AuthTabs from "./Pages/AuthTabs";
import TawkToChat from "./Components/TawkToChat";

function App() {
   const { userState } = useAuth();
   console.log(userState);

   //  return <>{userState.isAuthenticated ? <Route /> : <AuthTabs />}</>;
   return (
      <>
         <Route />
         <TawkToChat />
      </>
   );
}

export default App;
